import { NavigationStackParameters } from './navigation-stack-parameters';

interface INavigationStack {
    rootUrl: string;
    userEntryUrl: string;
    currentUrl?: string;
    clickAction: string;
    name: string;
    history: string[];
    parameters: NavigationStackParameters;
}

export class NavigationStack implements INavigationStack {
    public rootUrl: string;
    public currentUrl?: string;
    public clickAction: string;
    public name = '';
    public history: string[] = [];
    public parameters: NavigationStackParameters = {
        useCustomClickHandler: false,
        canBeActivatedByNav: false,
    };

    public get userEntryUrl() {
        return this.parameters.userEntryUrl ?? this.rootUrl;
    }

    public constructor({ rootUrl, name, clickAction, parameters }: Partial<INavigationStack> = {}) {
        this.rootUrl = rootUrl ?? this.rootUrl;
        this.name = name ?? this.name;
        this.clickAction = clickAction ?? this.clickAction;
        this.parameters = parameters ?? this.parameters;
    }
}
